import { Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import ImageCarousel from '../components/template/ImageCarousel';
import LeftRightList from '../components/template/LeftRightList';
import StandardHeaderText from '../components/template/StandardHeaderText';
import Subtitle from '../components/template/Subtitle';
import Table from '../components/template/Table';
import TextBlock from '../components/template/TextBlock';
import HeroImage from '../components/template/HeroImage';

/**
 * Shared utility for rendering content items in diff comparisons
 * Used by both ReviewContentComparisonView and FullContentDiffViewer
 */
export const createContentItemRenderer = (tone: keyof typeof Palette, modelId: string = '') => {
  return (item: any, modelIdParam: string, isOriginal: boolean) => {
    const key = `${item.id}-${isOriginal ? 'original' : 'new'}`;
    const effectiveModelId = modelIdParam || modelId;

    switch (item.type) {
      case 'StandardHeaderText':
        return (
          <StandardHeaderText
            key={key}
            {...item.properties}
            id={key}
            editMode={false}
            tone={tone}
          />
        );

      case 'Subtitle':
        return <Subtitle key={key} {...item.properties} id={key} tone={tone} />;

      case 'Text':
        return <TextBlock key={key} {...item.properties} id={key} tone={tone} />;

      case 'HeroImage':
        return <HeroImage key={key} {...item.properties} id={key} tone={tone} />;

      case 'ImageCarousel':
        return (
          <ImageCarousel
            key={key}
            {...item.properties}
            id={key}
            modelId={effectiveModelId}
            modelType="FundOpportunity"
            editMode={false}
            tone={tone}
            forceExpanded={true} // Force all cards to be expanded for diff comparison
          />
        );

      case 'LeftRightList':
        return (
          <LeftRightList key={key} {...item.properties} id={key} editMode={false} tone={tone} />
        );

      case 'Table':
        return <Table key={key} {...item.properties} id={key} editMode={false} tone={tone} />;

      default:
        return <Typography color="text.secondary">Unknown content type: {item.type}</Typography>;
    }
  };
};
